<template>
    <div :class="namespaceClass()">
        <layout name="WorkflowLayout">
            <template v-slot:header v-if="appEnv">
                <ChooseTypeHeader :class="namespaceClass('content')" :mwc-id="getMwcIdForChild('header')" @sign-out="handleSignOut"> </ChooseTypeHeader>
            </template>
            <div :class="namespaceClass('content')">
                <mds-section border="none" :title="getUILabel('type_title')" :headingLevel="1"></mds-section>
                <hypo-type :mwc-id="getMwcIdForChild('hypo-type')" @select-type="handleSelectType" :types="availableTypes"></hypo-type>
                <Dashboard :mwc-id="getMwcIdForChild('dashboard')" />
            </div>
        </layout>
        <!-- Delete below "preference-modal" after new preference page is implemented -->
        <!-- Deleting this might cause CSS problem in editAssumption page (mds-section__header-container___hypo margin-bottom = 0) -->
        <preference-modal :mwc-id="getMwcIdForChild('preference-modal')" v-model="showEditPreference" @changeLanguage="changeLanguage"> </preference-modal>
        <header-dialog
            :mwc-id="getMwcIdForChild('headerDialog')"
            :show="showDialog"
            :headerDialogConfig="dialogConfig"
            @dialog-close="dialogCloseHandler"
            @dialog-main-action="signOut"
        ></header-dialog>
    </div>
</template>

<script>
import HypoVueBaseMixin from "hypo-vue-base-mixin";
import MwcSharedMixin from "@/mixins/MwcSharedMixin";
import Layout from "../layouts/Layout";
import HypoType from "hypo-type/src/Type";
import ChooseTypeHeader from "./ChooseTypeHeader";
import * as types from "@/store/mutation-types.js";
import PreferenceModal from "./PreferenceModal";
import Dashboard from "../Dashboard/Dashboard";
import MdsSection from "@mds/section";
import HeaderDialog from "../NewWorkflow/HeaderDialog";

export default {
    mixins: [HypoVueBaseMixin, MwcSharedMixin],
    name: "choose-type",
    components: {
        Dashboard,
        Layout,
        HypoType,
        ChooseTypeHeader,
        PreferenceModal,
        HeaderDialog,
        MdsSection
    },
    data() {
        return {
            defaultConfig: {
                labels: this.$store.state.labels.labels
            },
            showEditPreference: false,
            showDialog: false,
            dialogConfig: {
                mainText: "common_sign_out_title",
                dialogType: "hypo", // "hypo", "portfolio"
                action: "signout", // "rename", "delete"
                dismissLabel: "common_stay_in",
                executeLabel: "common_yes"
            },
            typeMap: {
                PORTFOLIO: 0,
                PORTFOLIO_C: 1,
                INDVIL_H: 2,
                HOLDINGS_C: 3
            }
        };
    },
    created() {
        this.getHypofileCount();
    },
    computed: {
        availableTypes() {
            return this.getAvailableTypes(this.$store.getters["config/getHypoTypes"]);
        },
        appEnv() {
            return !process || process.env.VUE_APP_USAGE !== "component";
        }
    },
    methods: {
        getHypofileCount() {
            this.$fetch({
                url: "/api/v1/Hypo",
                method: "GET"
            }).then(respData => {
                this.$store.dispatch("notifications/setHypoCount", respData.totalCount);
                this.$store.dispatch("notifications/setHypoList", respData.entities);
            });
        },
        getAvailableTypes(hypoTypes) {
            return hypoTypes.map(type => {
                return {
                    id: type.reportId,
                    type: this.typeMap[type.reportId],
                    label: this.getUILabel(type.labelKey),
                    description: this.getUILabel(type.descriptionKey),
                    enabled: type.visible
                };
            });
        },
        async handleSelectType(type) {
            await this.$store.dispatch("clearHypoInput");
            // TO DO: refactor mutation used directly inside component -
            // https://vuex.vuejs.org/guide/actions.html#dispatching-actions && https://dev.to/timothyokooboh/vuex-best-practices-45dd
            this.$store.commit(`hypo/${types.SET_HYPO_TYPE}`, type);
            this.$store.dispatch("stepper/setFlow", type);
            this.$store.dispatch("investments/setPortfoliosByFlow");
            this.$router.push("/workflow/AddHoldings/0");
        },
        changeLanguage(languageId) {
            this.$store.commit(`preference/${types.SET_LANGUAGE_ID}`, languageId);
        },
        dialogCloseHandler() {
            this.showDialog = false;
        },
        handleSignOut() {
            this.showDialog = true;
        },
        signOut() {
            this.$fetch({
                url: "/api/v1/auth/logout",
                method: "POST"
            }).then(() => {
                this.$store.commit(`auth/${types.SET_TOKEN_EXPIRED_STATUS}`, true);
                window.location.href = encodeURI(`${window.location.origin}/login`);
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.choose-type {
    &-content {
        margin-left: auto;
        margin-right: auto;
        max-width: 1000px;
    }
    .content .choose-type-content {
        margin-top: $mds-space-3-x;
    }
}
.title_section {
    margin: $mds-space-3-x 0;
}
</style>
